import {Maybe} from "@src/types/global.types";

export enum ShipmentMethodKeyEnum {
    personal = 'personal',
    courier = 'courier',
    courier_customer = 'courier_customer',
    mobile = 'mobile',
}

export enum ShipmentMethodTypeEnum {
    incoming = 'incoming',
    outgoing = 'outgoing',
}

export interface ShipmentMethodListRequest {
    type: ShipmentMethodTypeEnum
}

export type ShipmentMethodType = {
    id: Maybe<string>
    createdAt: Maybe<string>
    updatedAt: Maybe<string>
    key: Maybe<ShipmentMethodKeyEnum>
    type: Maybe<ShipmentMethodTypeEnum>
    name: Maybe<string>
    position: Maybe<number>
    price: Maybe<string>
    active: Maybe<boolean>
    default: Maybe<boolean>
}